
import { Separator } from '@/components/ui/separator';
import { NewsSourceFilter } from './news/NewsSourceFilter';
import { NewsGrid } from './news/NewsGrid';
import { NewsPagination } from './news/NewsPagination';
import { NewsLoading } from './news/NewsLoading';
import { NewsError } from './news/NewsError';
import { useNewsFeed } from '@/hooks/useNewsFeed';
import { useLanguage } from '@/hooks/useLanguage';

export function NewsFeed() {
  const { t } = useLanguage();
  const {
    loading,
    error,
    currentPage,
    totalPages,
    selectedSources,
    getCurrentItems,
    formatDate,
    toggleSource,
    setCurrentPage
  } = useNewsFeed();

  return (
    <section id="news" className="py-20 bg-secondary/50 dark:bg-secondary/20">
      <div className="container px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl text-foreground">
            {t('news.title')}
          </h2>
          <Separator className="mt-4 mb-8 mx-auto w-24 bg-primary/50" />
        </div>
        
        {/* Source filters */}
        <NewsSourceFilter
          sources={selectedSources}
          onToggleSource={toggleSource}
        />
        
        {loading ? (
          <NewsLoading />
        ) : error ? (
          <NewsError error={error} />
        ) : (
          <>
            <NewsGrid 
              newsItems={getCurrentItems()} 
              formatDate={formatDate} 
            />
            
            {/* Pagination */}
            <NewsPagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />
          </>
        )}
      </div>
    </section>
  );
}
